import { render, staticRenderFns } from "./ResBadgeHolderView.vue?vue&type=template&id=100f8f1c&scoped=true"
import script from "./ResBadgeHolderView.vue?vue&type=script&lang=js"
export * from "./ResBadgeHolderView.vue?vue&type=script&lang=js"
import style0 from "./ResBadgeHolderView.vue?vue&type=style&index=0&id=100f8f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f8f1c",
  null
  
)

export default component.exports